import { createServiceDropdown } from "./fancy-dropdowns.3e2d7c0fd3ef.js";
import CustomAmplitudeClient from "./custom-amplitude-client.5bf7487b6bc5.js";
import"./contact-us.5efd01d9ae6d.js";
import {
  ServiceSelectorChangedEvent,
  ServiceSelectorClearedEvent,
} from "./service-selector-events.16cbf3510c34.js";
import { InsuranceSelectorChangedEventType } from "./insurance-selector-events.b006bae191bd.js";
import { MOBILE_SCREEN_QUERY } from "./shared.966473804198.js";

export class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.root = this.getRootNode();
    this.config = JSON.parse(
      this.root.querySelector("#page-config").textContent,
    );

    if (!this.config) throw new Error("unable to load page config");
    this.amplitudeClient = new CustomAmplitudeClient(this.config.analyticsUrl);
  }

  connectedCallback() {
    const searchBarContainer = this.root.querySelector(".search-bar");
    this.amplitudeClient.setupSearchBarAnalytics(searchBarContainer);

    const form = this.root.querySelector("#rates-form");
    if (form) {
      form.addEventListener("submit", this.handleFormSubmit);
    }

    this.root.addEventListener(
      InsuranceSelectorChangedEventType,
      this.clearInsuranceValidation,
    );

    const serviceCodeEl = this.root.querySelector("#service_code");
    this.serviceDropdown = createServiceDropdown(
      serviceCodeEl,
      this.config.servicesUrl,
      this.config.browseUrl,
    );

    this.serviceDropdown.on("change", this.handleServiceSelectionChange);
    this.serviceDropdown.on("change", this.advance);
  }

  handleServiceSelectionChange = () => {
    const serviceSelector = this.root.querySelector("#service_code");
    if (!serviceSelector) {
      return;
    }

    const selectedValue = this.serviceDropdown.getValue();
    const hasSelection =
      Array.isArray(selectedValue) && selectedValue.length === 0
        ? false
        : Boolean(selectedValue);
    const event = hasSelection
      ? new ServiceSelectorChangedEvent({
          value: Array.isArray(selectedValue)
            ? selectedValue[0]
            : selectedValue,
        })
      : new ServiceSelectorClearedEvent();

    serviceSelector.dispatchEvent(event);
  };

  clearInsuranceValidation = () => {
    const validationAnchor = this.root.querySelector(
      ".insurance-validation-anchor",
    );
    if (validationAnchor) {
      validationAnchor.setCustomValidity("");
    }
  };

  handleFormSubmit = (e) => {
    const form = e.target;
    const planInput = form.querySelector('input[name="plan"]');

    if (planInput && !planInput.value) {
      e.preventDefault();
      const validationAnchor = this.root.querySelector(
        ".insurance-validation-anchor",
      );
      if (validationAnchor) {
        validationAnchor.setCustomValidity("Please select an insurance plan");
        validationAnchor.reportValidity();
      }
    }
  };

  advance = () => {
    if (MOBILE_SCREEN_QUERY.matches) {
      document.activeElement?.blur();
    } else {
      this.root.getElementById("care-location").focus();
    }
  };
}

customElements.define("search-form", SearchForm);
